/* 🤖 this file was generated by svg-to-ts */
export const matIconMan: {
  name: 'man';
  data: string;
} = {
  name: 'man',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M14 7h-4c-1.1 0-2 .9-2 2v6h2v7h4v-7h2V9c0-1.1-.9-2-2-2z"/><circle cx="12" cy="4" r="2"/></svg>`
};
